const actions = {
  listar: async (
    context,
    {
      status,
      per_page,
      current_page,
      vendor_id,
      vendor_id_voucher,
      id,
      cost_center_search,
      plantiff_search,
      categoria,
      initial_date,
      final_date,
      somente_deletados,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get("vouchers", {
      params: {
        status,
        per_page,
        page: current_page,
        vendor_id,
        vendor_id_voucher,
        id,
        cost_center_search,
        plantiff_search,
        categoria,
        initial_date,
        final_date,
        somente_deletados,
      },
    });
    return response;
  },

  listarUserLogado: async (
    context,
    {
      status,
      per_page,
      current_page,
      vendor_id,
      vendor_id_voucher,
      id,
      cost_center_search,
      plantiff_search,
      categoria,
      initial_date,
      final_date,
      somente_deletados,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get("vouchers/logged-user", {
      params: {
        status,
        per_page,
        page: current_page,
        vendor_id,
        vendor_id_voucher,
        id,
        cost_center_search,
        plantiff_search,
        categoria,
        initial_date,
        final_date,
        somente_deletados,
      },
    });
    return response;
  },

  listarDeletados: async (
    context,
    { per_page, current_page, somente_deletados, plantiff_search, vendor_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get("vouchers", {
      params: {
        somente_deletados,
        per_page,
        page: current_page,
        plantiff_search,
        vendor_id,
      },
    });

    return response;
  },

  buscarDetalheRequisicao: async (context, { reqId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/${reqId}`);

    return response;
  },

  aprovar: async (context, { reqId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vouchers/${reqId}/approve`, {
      voucher_id: reqId,
      action: "approve",
    });
    return response;
  },

  excluir: async (context, { reqId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vouchers/${reqId}/reject`, {
      voucher_id: reqId,
      action: "reject",
    });
    return response;
  },

  excluirFinalizado: async (context, { voucher_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vouchers/${voucher_id}/cancel`);
    return response;
  },

  exportar: async (
    context,
    { vendor_id, vendor_id_voucher, status, cost_center }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/report/em-aberto`, {
      params: {
        vendor_id_voucher,
        vendor_id,
        download: "xlsx",
        data_inicial: "01/01/2021",
        status,
        cost_center,
      },
    });
    return response;
  },

  exportarUserLogado: async (
    context,
    { vendor_id, vendor_id_voucher, status, cost_center }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/report/em-aberto/logged-user`, {
      params: {
        vendor_id_voucher,
        vendor_id,
        download: "xlsx",
        data_inicial: "01/01/2021",
        status,
        cost_center,
      },
    });
    return response;
  },

  finalizar: async (
    context,
    {
      reqId,
      imagemBase64,
      idUsuario,
      date,
      mensagem,
      batches,
      auth_type,
      voucher_reason,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vouchers/${reqId}/finish`, {
      withdrawn_by: {
        auth_type,
        auth_content: imagemBase64,
        user_id: idUsuario,
        timestamp: date,
        voucher_reason,
        liveness_check: auth_type == "facial" ? 1 : undefined,
      },
      comment: mensagem,
      batches,
    });
    return response;
  },

  recuperarDeletado: async (context, { reqId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/${reqId}/voltar-deletado`);
    return response;
  },

  listarSolicitante: async (
    context,
    { card_id, per_page, vendor_id, search }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/auth/users`, {
      params: {
        card_id,
        per_page,
        vendor_id,
        search,
      },
    });
    return response;
  },

  listarProdutos: async (
    context,
    {
      per_page = 5,
      vendor_id,
      search,
      contract_id,
      plantiff_id,
      has_ca,
      category_id,
      saldo,
      grupo_id,
      ca,
      ca_status,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/vouchers/products`, {
      params: {
        per_page,
        vendor_id,
        search,
        contract_id,
        plantiff_id,
        has_ca,
        category_id,
        saldo,
        grupo_id,
        ca,
        ca_status,
      },
    });

    return response;
  },

  verificaQuantidadedHttp: async (context, { userId, productId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/auth/users/${userId}/produto/${productId}/regras-troca`
    );
    return response;
  },

  listarProdutosLiberados: async (
    context,
    {
      per_page,
      vendor_id,
      search,
      user_id,
      grupo_id,
      category_id,
      saldo,
      ca,
      ca_status,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/product-groups/users/${user_id}/produtos-por-grupo`,
      {
        params: {
          per_page,
          vendor_id,
          search,
          grupo_id,
          category_id,
          saldo,
          ca,
          ca_status,
        },
      }
    );
    return response;
  },

  listarProdutosMachine: async (
    context,
    { per_page, vendor_id, user_id, search }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/machine/users/${user_id}/products`, {
      params: {
        per_page,
        vendor_id,
        search,
      },
    });
    return response;
  },

  listarGrupos: async (context, { per_page, vendor_id, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/product-groups`, {
      params: {
        per_page,
        vendor_id,
        search,
      },
    });
    return response;
  },

  criarRequisicao: async (
    context,
    {
      cost_center_id,
      description,
      plantiff_id,
      products,
      vendor_id,
      voucher_reason,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/vouchers`, {
      cost_center_id,
      description,
      plantiff_id,
      products,
      vendor_id,
      voucher_reason,
    });
    return response;
  },

  userLogado: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/auth/me`);
    return response;
  },

  detalharVoucher: async (context, { voucher_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/${voucher_id}`);
    return response;
  },

  detalharVoucherUserLogado: async (context, { voucher_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/${voucher_id}/logged-user`);
    return response;
  },

  atualizarQuantidade: async (
    context,
    { voucher_id, description, products }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vouchers/${voucher_id}`, {
      description,
      products,
    });
    return response;
  },

  uploadUrl: async (context, { nome_arquivo }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`vouchers/documento`, {
      nome_arquivo,
    });
    return response;
  },

  uploadDocumento: async (context, { voucher_id, url, observacao }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vouchers/${voucher_id}/documento`, {
      url,
      observacao,
    });
    return response;
  },

  criarTransferencia: async (
    context,
    {
      deposito_id_entrada,
      deposito_id_saida,
      descricao,
      solicitante_id,
      transferir_estoque,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`transferencia-estoque`, {
      deposito_id_entrada,
      deposito_id_saida,
      descricao,
      solicitante_id,
      transferir_estoque,
    });

    return response;
  },

  listarDocumentos: async (context, { voucher_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vouchers/${voucher_id}/documentos`);
    return response;
  },

  deletarDocumentos: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`vouchers/documento/${uuid}`);

    return response;
  },

  enviarImageBiometria: async (context, { voucher_id, image }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`vouchers/biometry`, {
      voucher_id,
      image,
    });

    return response;
  },
  // Fluxo Completo
  listarContratos: async (context, { per_page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vendors/users`, {
      params: {
        per_page,
      },
    });
    return response;
  },

  checarPin: async (context, { pin, user_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`auth/users/checar-pin`, {
      pin,
      user_id,
    });

    return response;
  },
  // Requisição SEG
  listarCentrosCustos: async (context, { vendor_id, per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cost-centers`, {
      params: {
        vendor_id,
        per_page,
        search,
      },
    });

    return response;
  },

  listarProdutosListagemSimplificada: async (
    context,
    { vendor_id, grupo_id, com_estoque, produto, per_page, saldo }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`products/listagem-simples`, {
      params: {
        vendor_id,
        grupo_id,
        com_estoque,
        produto,
        per_page,
        saldo,
      },
    });

    return response;
  },

  //Tabela Historico Retirada

  listarHistoricoRetirada: async (
    context,
    { dataInicial, item, solicitante, page, perPage }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi/consumo`, {
      params: {
        dataInicial,
        item,
        perPage,
        solicitante,
        page,
      },
    });

    return response;
  },

  fichaEPI: async (context, { voucher_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi/consumo`, {
      params: {
        voucher_id,
      },
    });

    return response;
  },

  listarOrdem: async (context, { numero, per_page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ordem-de-servico/listagem-simplificada`, {
      params: {
        data_inicial: "01/01/2001",
        per_page,
        numero,
      },
    });

    return response;
  },

  produtosTroca: async (context, { contract_id, group_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`contracts/${contract_id}/products`, {
      params: {
        group_id,
        per_page: 200,
      },
    });

    return response;
  },
  produtosTrocaConcluir: async (context, { requisicao_id, produtos }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`requisicao/troca-produto`, {
      requisicao_id,

      produtos,
    });

    return response;
  },

  escolherOrdem: async (context, { voucher_id, osid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `ordem-de-servico/${osid}/vincular-voucher/${voucher_id}`,
      {
        params: {
          voucher_id,
          osid,
        },
      }
    );

    return response;
  },

  removerOrdem: async (context, { voucher_id, osid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `ordem-de-servico/${osid}/desvincular-voucher/${voucher_id}`,
      {
        params: {
          voucher_id,
          osid,
        },
      }
    );

    return response;
  },

  buscarUsuarioPorCracha: async (context, { card_id, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/auth/users`, {
      params: {
        card_id,
        vendor_id,
        per_page: 1,
      },
    });
    return response;
  },

  cancelarParcial: async (context, { voucher_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vouchers/${voucher_id}/partially-cancel`, {
      products,
    });

    return response;
  },
};

export const requisicao = {
  namespaced: true,
  actions,
};
